import * as React from "react"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import ListSubheader from "@mui/material/ListSubheader"
import DashboardIcon from "@mui/icons-material/Dashboard"
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"
import PeopleIcon from "@mui/icons-material/People"
import BarChartIcon from "@mui/icons-material/BarChart"
import LayersIcon from "@mui/icons-material/Layers"
import AssignmentIcon from "@mui/icons-material/Assignment"
import { useLocation, useNavigate } from "react-router-dom"

export const MainListItems = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const goTo = (route) => {
    navigate(route)
  }

  return (
    <React.Fragment>
      <ListItemButton
        onClick={() => goTo("/")}
        selected={location.pathname === "/"}
      >
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Tablero" />
      </ListItemButton>
      <ListItemButton
        onClick={() => goTo("/posts")}
        selected={location.pathname === "/posts"}
      >
        <ListItemIcon>
          <LayersIcon />
        </ListItemIcon>
        <ListItemText primary="Publicaciones" />
      </ListItemButton>
      <ListItemButton
        onClick={() => goTo("/transactions")}
        selected={location.pathname === "/transactions"}
      >
        <ListItemIcon>
          <ShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary="Transacciones" />
      </ListItemButton>
      <ListItemButton
        onClick={() => goTo("/users")}
        selected={location.pathname === "/users"}
      >
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary="Usuarios" />
      </ListItemButton>

      <ListItemButton
        onClick={() => goTo("/logs")}
        selected={location.pathname === "/logs"}
      >
        <ListItemIcon>
          <BarChartIcon />
        </ListItemIcon>
        <ListItemText primary="Logs" />
      </ListItemButton>
    </React.Fragment>
  )
}

export const SecondaryListItems = () => {
  return (
    <React.Fragment>
      <ListSubheader component="div" inset>
        Configuración
      </ListSubheader>
      <ListItemButton>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Niveles de acceso" />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Capítulos" />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Opciones" />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Pagos" />
      </ListItemButton>
    </React.Fragment>
  )
}
